import { DataQueryKey, UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import {
  FindCustomersToCopyParams,
  FindOrdersCountParams,
  FindSimpleOrdersListParams,
} from './orders.types';

export const getFindOrdersCountKey = (params: FindOrdersCountParams): UseDataQuery['queryKey'] => [
  'orders-count',
  undefined,
  params ?? {},
];

export const getFindSimpleOrdersListKey = (
  params: FindSimpleOrdersListParams,
): UseDataQuery['queryKey'] => [DataQueryKey.SIMPLE_ORDERS, undefined, params ?? {}];

export const getMaxSubtotalKey = (): UseDataQuery['queryKey'] => [
  DataQueryKey.MAX_SUBTOTAL_OF_ORDERS,
  undefined,
];

export const getTeamOrdersKey = (brandId?: string): UseDataQuery['queryKey'] => [
  'team-orders',
  undefined,
  { brandId },
];

export const getFindCustomersToCopyKey = (
  params: FindCustomersToCopyParams,
): UseDataQuery['queryKey'] => ['customers-to-copy', undefined, params ?? {}];
